import React, { Component } from 'react';
import SizeSelectionTires from '../SizeSelectionTires';
import '../../statics/stylesheet.css';


export default class PopUpContainerTires extends Component {


  render() {

    //const props = this.props;
    const { params } = this.props;
    const { category, search_by } = params;
    this.props.params.category = 'Tires';
    this.props.params.search_by = 'Size';

    return (
            <div className="popUp-backgroundDiv">
              <div className="popUp-InformationDiv">
                <div className="popUp-innerInformationDiv" style={{ backgroundColor: '#00000000' }}>
                       <SizeSelectionTires params={params}/>
                </div>
               </div>
            </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/subcomponents/PopUpContainerTires.js